import React from 'react';
import {Button, Card, Form, InputNumber, Typography} from "antd";
import BigNumber from "bignumber.js";
import utils from "../../common/utils";
import FloatLabelNumberComponent from "../common/FloatLabelNumberComponent";
import {Translation} from "react-i18next";
import LoadingSvg from "../common/LoadingSvg";
import {debounce, find} from 'lodash';
import consts from "../../consts";
import ModalValidateLoadingComponent from "../common/ModalValidateLoadingComponent";
import ConfirmModal from '../modals/ConfirmModal';
import {object, number} from 'yup';
import BaseOrderComponent from "../common/BaseOrderComponent";

const {Text} = Typography;

class OrderMarketComponent extends BaseOrderComponent {
  yupValidate = object().shape({
    amount: number().required().moreThan(0),
  });
  
  constructor(props) {
    super(props);
    
    // const isBuy = this.props.tradeType === window.c.ORDER_TRADE_TYPE_BUY_STR;
    // const total = window._.get(this.props.userBalances[isBuy ? this.props.currency : this.props.coin], 'available_balance', 0);
    this.state = {
      ...this.state,
      params: {
        amount: 0,
        total: 0,
        balance: 0,
      },
      isVisible: false,
    }
  }
  
  componentWillReceiveProps(nextProps, nextContext) {
    // if (!!nextProps.isClickedOrderBookBuy) {
    //
    // }
  }
  
  onAmountChange(amount) {
    // const total = utils.trimRightZero(new BigNumber(amount).times(this.state.params.price).toFixed(8));
    this.setState({params: {...this.state.params, amount}})
  }
  
  async validate() {
    
    let balance = this.getUserBalance();
    let validAmount = number().required().moreThan(0).label(window.$t('amount'));
    let validBalance = number().required().moreThan(0).label(window.$t('user.account_balance.balance'));
    this.state.params.balance = balance;
    let fields = {
      amount: this.isBuy() ? validAmount : validAmount.max(balance, window.$t('Balance insufficient')),
    };
    if (this.isBuy()) {
      fields.balance = validBalance;
    }
    this.yupValidate = object().shape(fields);
    
    return super.validate();
  }
  
  createBuyOrder = debounce(() => {
    this.hideModal();
    this.enLoading();
    this.props.onAddOrderAction({
      coin: this.props.coin,
      currency: this.props.currency,
      quantity: parseFloat(this.state.params.amount),
      trade_type: window.c.ORDER_TRADE_TYPE_BUY,
      type: window.c.ORDER_TYPE_MARKET,
    }, () => {
      this.unLoading();
      this.clearOrder();
    });
  }, consts.DEFAULT_DURATION);
  
  createSellOrder = debounce(() => {
    this.hideModal();
    this.enLoading();
    this.props.onAddOrderAction({
      coin: this.props.coin,
      currency: this.props.currency,
      quantity: parseFloat(this.state.params.amount),
      trade_type: window.c.ORDER_TRADE_TYPE_SELL,
      type: window.c.ORDER_TYPE_MARKET,
    }, () => {
      this.unLoading();
      this.clearOrder();
    });
  }, consts.DEFAULT_DURATION);
  
  isBuy = () => {
    return this.props.tradeType === window.c.ORDER_TRADE_TYPE_BUY_STR;
  }
  
  getUserBalance = () => {
    return window._.get(this.props.user.userBalances[this.isBuy() ? this.props.currency : this.props.coin], 'available_balance', 0)
  }
  
  clearOrder = () => {
    this.setState({
      params: {
        amount: 0,
        total: 0,
        balance: 0,
      }
    });
  }
  
  onSlide = (slideValue) => {
    this.setState({
      slideValue,
      params: { ...this.state.params, amount: new BigNumber(this.getUserBalance()).div(100).times(slideValue).toString(10)}
    });
  }
  
  render() {
    const CacheSlider = this.renderSlider;
    
    const layout = {
      wrapperCol: {span: 24},
    };
    const tailLayout = {
      wrapperCol: {span: 24},
    };
    const upperCoin = `${this.props.coin}`.toUpperCase();
    const upperCurrency = `${this.props.currency}`.toUpperCase();
  
    const amountPrecision = utils.getPrecision(this.coinSetting?.minimum_quantity_precision || 0.00000001);
    const totalPrecision = utils.getPrecision(this.coinSetting?.minimum_amount_precision || 0.00000001);
    const precision = this.isBuy() ? totalPrecision : amountPrecision
    return (
      <Translation>
        {(t) => <div className="order-stop-limit-wrap">
          <Card className="order-card" loading={false}>
            <Form
              {...layout}
              name="basic"
            >
              <div className="mb-medium" style={{color: "#76808F"}}>
                {t('exchange.order_market.available')}: {utils.formatCurrency(this.getUserBalance())} {this.isBuy() ? upperCurrency : upperCoin}
              </div>
              <Form.Item
                rules={[{required: true, message: t('exchange.order_market.amount_field_is_required')}]}
              >
                <FloatLabelNumberComponent
                  min={0}
                  customPrecision={precision}
                  name="amount"
                  label={t('exchange.order_market.amount')}
                  suffix={upperCoin}
                  value={this.state.params.amount}
                  onChange={(value) => this.onAmountChange(value, precision)}
                  overrideFocus={this.clearErrors}
                  className="bg-313337"
                />
                <div className="text-left p-abs no-wrap">
                  <Text type='danger'>{utils.upperCaseFirst(this.state.errors.amount || this.state.errors.balance || '')}</Text>
                </div>
              </Form.Item>
  
              <CacheSlider slideValue={this.state.slideValue} />
              
              <Form.Item {...tailLayout}>
                {
                  this.isBuy() ?
                    <Button type="primary" htmlType="submit" onClick={this.showModal}
                            className={this.isBuy() ? 'bg-buy w-100' : 'bg-sell w-100'}
                            disabled={this.state.isLoading}
                            icon={<LoadingSvg name='bars' hidden={!this.state.isLoading} size={20}/>}
                    >
                      {!this.state.isLoading && `${t('exchange.order_market.buy')} ${upperCoin}`}
                    </Button> :
                    <Button type="primary" htmlType="submit" onClick={this.showModal}
                            className={this.isBuy() ? 'bg-buy w-100' : 'bg-sell w-100'}
                            disabled={this.state.isLoading}
                            icon={<LoadingSvg name='bars' hidden={!this.state.isLoading} size={20}/>}
                    >
                      {!this.state.isLoading && `${t('exchange.order_market.sell')} ${upperCoin}`}
                    </Button>
                }
              </Form.Item>
            </Form>
            
            <ConfirmModal
              title={t('common.notification')}
              okText={t('common.confirm')}
              okType={'primary'}
              cancelText={t('common.cancel')}
              onConfirm={this.isBuy() ? this.createBuyOrder : this.createSellOrder}
              onCancel={this.hideModal}
              isVisible={this.state.isVisible}>
              <div>{t('user.withdrawal.question')}</div>
            </ConfirmModal>
          </Card>
        </div>}
      </Translation>
    );
  }
}

export default OrderMarketComponent;
